export class NewsService {
  constructor($resource, ApiService, $cookies) {
    "ngInject";

    this.$cookies = $cookies;
    this.$resource = $resource;
    this.apiService = ApiService;

    //url
    this.newsUrl = this.apiService.getResourceUrl("/news");
    this.newswithIdUrl = this.apiService.getResourceUrl("/news/:id");

    //resource
    this.individualResource = this.$resource(this.newsUrl, null, {
      getDetails: { method: "get" },
      update: { method: "post" },
    });

    this.individualResourceWithId = this.$resource(this.newswithIdUrl, null, {
      getDetails: { method: "get" },
      update: { method: "put" },
      delete: { method: "delete" },
    });
  }

  getNewsList() {
    const promise = this.individualResource.getDetails().$promise;
    return promise
      .then(({ details }) => this.getModifiedList(details))
      .catch((error) => {
        console.log("error", error);
      });
  }

  getModifiedList({ newsList, newsCount }) {
    newsList = newsList.map((value) => {
      value.imageUrl = this.apiService.getImageUrl(value.fileUuid);
      return value;
    });
    const newsListDetails = {
      data: newsList,
      count: newsCount || newsList.length,
      config: {
        defaultColumn: {
          columnName: "sortOrder", //default column name
          order: "ASC", //ASC = Ascending , DES = Descending, DEF = Default
        },
        columnDefs: [
          {
            type: "image",
            enableSort: false,
            field: "imageUrl",
            displayName: "IMAGE",
            defaultImageUrl: "/images/news-default-icon.svg",
          },
          {
            field: "title",
            enableSort: true,
            displayName: "TITLE",
            showEnableSortImage: true,
          },
          {
            field: "link",
            enableSort: false,
            displayName: "LINK",
            rowClass: "underline-field",
            className: "news-link",
          },
          {
            field: "summary",
            enableSort: false,
            displayName: "SUMMARY",
            className: "text-break news-max-width",
          },
          {
            type: "date",
            enableSort: true,
            displayName: "DATE",
            field: "publishDate",
            format: "dd MMMM yyyy",
            showEnableSortImage: true,
          },
          {
            type: "View",
            field: "view",
            enableSort: false,
          },
          {
            type: "Edit",
            field: "edit",
            enableSort: false,
          },
          {
            type: "Delete",
            field: "delete",
            enableSort: false,
          },
        ],
      },
    };
    return newsListDetails;
  }

  getNewsEditDetails(id) {
    const promise = this.individualResourceWithId.getDetails({ id }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        console.log("error", error);
      });
  }

  updateNews(details, type) {
    const _promise =
      type === "add"
        ? this.individualResource.update(details)
        : this.individualResourceWithId.update(
            { id: details.newsId },
            {
              link: details.link,
              title: details.title,
              summary: details.summary,
              fileUuid: details.fileUuid,
              newsTagIds: details.newsTagIds,
              publishDate: details.publishDate,
              newsCategoryIds: details.newsCategoryIds,
            }
          );
    const promise = _promise.$promise;
    return promise.then((response) => response);
  }

  deleteNews(selectedId) {
    const promise = this.individualResourceWithId.delete({
      id: selectedId,
    }).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        console.log("error", error);
      });
  }

  getNewsListByParams(params) {
    const promise = this.individualResource.getDetails(params).$promise;
    return promise.then(({ details }) => {
      return this.getModifiedList(details);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/news/news.service.js